import { Button, Row } from "antd";
import React, { useState } from "react";
import TmsModal from "../../../../../../components/tms-customs/tms-modal";
import TmsSmRalLeaseList from "../created-list-inner-pages/tms-sm-ral-land-lease-list";
import TmsLandLeaseCreation from "../creation-inner-pages/tms-land-lease-creation";
const LandleaseIndex = () => {
  const [visible, setVisible] = useState(false);

  return (
    <div>
      <Row justify="start">
        <Button
          type="primary"
          onClick={() => {
            setVisible(true);
          }}
        >
          New Lease Creation
        </Button>
      </Row>
      <br />
      {!visible && <TmsSmRalLeaseList />}
      <TmsModal
        centered={true}
        width="80%"
        closable={false}
        visible={visible}
        title={"Land Lease Creation "}
        onClose={() => {
          setVisible(false);
        }}
      >
        {visible && <TmsLandLeaseCreation setVisible={setVisible} />}
      </TmsModal>
    </div>
  );
};

export default LandleaseIndex;
